import { render, staticRenderFns } from "./TheSourcePanel.vue?vue&type=template&id=545a95a2&scoped=true&"
import script from "./TheSourcePanel.vue?vue&type=script&lang=js&"
export * from "./TheSourcePanel.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePanel.vue?vue&type=style&index=0&id=545a95a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a95a2",
  null
  
)

export default component.exports